var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCottonBuds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2855 2.71447C22.469 3.8979 22.1492 6.13641 20.5712 7.71431C19.5083 8.77727 17.6085 8.73224 16.4817 8.58964L8.58969 16.4815C8.73232 17.6083 8.77742 19.5082 7.71438 20.5713C6.13646 22.1492 3.89793 22.469 2.71448 21.2855C1.53104 20.1021 1.85083 17.8636 3.42875 16.2857C4.49164 15.2228 6.39125 15.2678 7.51807 15.4103L15.4103 7.51822C15.2677 6.39144 15.2227 4.49168 16.2856 3.42874C17.8635 1.85083 20.1021 1.53104 21.2855 2.71447Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCottonBuds);
export default __webpack_public_path__ + "static/media/cotton-buds.f9549bbc76cff1c6d8b1bededa5de9ab.svg";
export { ForwardRef as ReactComponent };